import * as Sentry from '@sentry/browser';
import Vue from 'vue';

import ActivitySubscription from './backend/components/ActivitySubscription.vue';
import ManageSubscriptionButton from './backend/components/ManageSubscriptionButton.vue';
import SubscriptionsList from './backend/components/SubscriptionsList.vue';
import ActivitySubscriptionsPage from './backend/views/ActivitySubscriptionsPage.vue';

/**
 * We'll instantiate Sentry to capture all Javascript errors.
 */

if (process.env.MIX_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN,
  });
}

/**
 * Yeah, lodash!
 */
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

global.$ = global.jQuery = require('jquery');

require('bootstrap-sass');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common = {
  'X-CSRF-TOKEN': window.Laravel.csrfToken,
  'X-Requested-With': 'XMLHttpRequest',
};

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });

/**
 * SweetAlert 2
 */
window.swal = require('sweetalert2');

/**
 * Moment.js
 */
window.moment = require('moment');

/**
 * Toastr
 */
window.toastr = require('toastr');

/**
 * Copy to clipboard.
 */
const copy = require('copy-to-clipboard');

global.$(function () {
  global.$('body').on('click', '.copy-to-clipboard', function () {
    if (!this.dataset.clipboardText) {
      return;
    }

    if (
      copy(this.dataset.clipboardText, {
        format: 'text/plain',
      })
    ) {
      window.toastr.info('Copied');
    }
  });
});

/**
 * Metafizzy.co Isotope
 */
require('isotope-layout/dist/isotope.pkgd.min');

Vue.component('activity-subscriptions-page', ActivitySubscriptionsPage);
Vue.component('subscriptions-list', SubscriptionsList);
Vue.component('activity-subscription', ActivitySubscription);
Vue.component('manage-subscription-button', ManageSubscriptionButton);
